import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { IoArrowBack, IoArrowForward } from "react-icons/io5";

// Components
import Button from "../../button";

// Styles
import styles from "./Navigation.module.css";

interface NavigationProps {
  onNext: () => void;
  onPrevious: () => void;
  isFirstCard: boolean;
  isLastCard: boolean;
  isFlipped: boolean;
  handleFlip: () => void;
  onCorrect?: () => void;
  onIncorrect?: () => void;
}

const Navigation: React.FC<NavigationProps> = ({
  onNext,
  onPrevious,
  isFirstCard,
  isLastCard,
  isFlipped,
  handleFlip,
  onCorrect,
  onIncorrect
}) => {
  const { t } = useTranslation();

  // Keyboard navigation
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      switch (event.key) {
        case 'ArrowLeft':
          if (!isFirstCard) {
            event.preventDefault();
            onPrevious();
          }
          break;
        case 'ArrowRight':
        case ' ':
          if (!isLastCard && isFlipped) {
            event.preventDefault();
            onNext();
          } else if (!isFlipped) {
            event.preventDefault();
            handleFlip();
          }
          break;
        case 'c':
        case 'C':
          if (isFlipped && onCorrect) {
            event.preventDefault();
            onCorrect();
          }
          break;
        case 'i':
        case 'I':
          if (isFlipped && onIncorrect) {
            event.preventDefault();
            onIncorrect();
          }
          break;
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onNext, onPrevious, isFirstCard, isLastCard, isFlipped, onCorrect, onIncorrect]);

  return (
    <div className={styles.container}>
      <div className={styles.navigationButtons}>
        {/* <Button
          type="secondary"
          onClick={onPrevious}
          disabled={isFirstCard}
          className={styles.navButton}
        >
          <span className="hidden md:block"><IoArrowBack /></span>
          {t('flashcardReview.actions.previous')}
        </Button> */}

        <Button
          type="primary"
          onClick={onNext}
          className={`${styles.navButton} primary-button`}
        >
          {isLastCard ? t('flashcardReview.actions.finish') : t('flashcardReview.actions.next')}
          <span className="hidden md:block"><IoArrowForward /></span>
        </Button>
      </div>

      <div className={styles.keyboardHints}>
        <span className={styles.hint}>
          {t('flashcardReview.keyboardHints')}
        </span>
      </div>
    </div>
  );
};

export default Navigation;